export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 6_08.3bbaf60a.jpg";